import {DtoModel} from '../../../entity/dto/dto.model';
import {LovValueSummary} from '../../../lov/lov-value/api/model/lovValueSummary.model';

export class ExternalIdModel implements DtoModel {

    externalId: string;
    application: LovValueSummary;
}
